import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import { Article, getIllustrationPath } from "./articleHelpers";
import Stack from "@mui/material/Stack";
import config from "./config";

const timeOptions = {
  timeZone: "Europe/Paris",
  month: "long",
  day: "numeric",
  year: "numeric",
  hour: "numeric",
  minute: "numeric",
} as const;

const formatDate = (date: number) =>
  `${new Date(date).toLocaleDateString("fr-FR", timeOptions)} (heure de Paris)`;

const SingleArticle: React.FC<{
  articleId: string;
  article: Article;
}> = ({ articleId, article }) => (
  <Card
    sx={{
      display: "flex",
      m: 1,
      justifyContent: "space-between",
    }}
  >
    <CardContent>
      {article.illustrationHash && (
        <CardMedia
          component="img"
          height="140"
          image={getIllustrationPath(articleId, article.illustrationHash)}
          alt="illustration"
        />
      )}
      <Stack direction="row" spacing={1}>
        <Typography variant="h2">{article.title}</Typography>
        <Button component={Link} to={`/edit-article/${articleId}`}>
          Éditer l'article
        </Button>
      </Stack>
      <Stack direction="row" spacing={1}>
        {article.createdByUser && (
          <Chip
            label={`Créé par vous le ${
              article.createdAt && formatDate(article.createdAt)
            }`}
          />
        )}
        {article.deployedAt && (
          <Chip
            label={`Mis en ligne le ${formatDate(article.deployedAt)}`}
            sx={{ mr: 1 }}
          />
        )}
        {article.blog && <Chip label={config.defaultBlog} />}
      </Stack>
    </CardContent>
  </Card>
);

export default SingleArticle;
